import { render, staticRenderFns } from "./ModificaBarca.vue?vue&type=template&id=427a2ad9&scoped=true&"
import script from "./ModificaBarca.vue?vue&type=script&lang=js&"
export * from "./ModificaBarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a2ad9",
  null
  
)

export default component.exports